module.exports = "/fonts/vendor/material-design-icons-icondist/MaterialIcons-Regular.eot?28d729e6d7a187ee4978ee7bb4401ac1";